import React from "react";
import { Button, Modal } from "antd";
import styled from "@emotion/styled";

import StatusImg from "../../assets/images/completed_status.svg";

const ConfirmModal = ({
  onCancel,
  visible,
  onSubmit,
  hasConfirmationBeenCompleted,
  topic,
  remark,
}) => {
  return (
    <StyledModal closable={false} footer={null} visible={visible}>
      {hasConfirmationBeenCompleted ? (
        <>
          <Image src={StatusImg} />
          <TopicConfirm>{topic}</TopicConfirm>
          <Remark>{remark}</Remark>
        </>
      ) : (
        <>
          <TopicConfirm>{topic}</TopicConfirm>
          <Remark>
            ยืนยันการบันทึกข้อมูลหรือไม่ <br />
            หากยืนยันแล้วจะไม่สามารถ <br />
            กลับมาแก้ไขได้
          </Remark>
          <ConfirmBtn onClick={onSubmit}>ยืนยัน</ConfirmBtn>
          <CancelBtn onClick={onCancel}>กลับไปแก้ไข</CancelBtn>
        </>
      )}
    </StyledModal>
  );
};

export default ConfirmModal;

const TopicConfirm = styled.h5`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #058459;
  margin-bottom: 4px;
`;
const Remark = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-bottom: 16px;
  white-space: pre-line;
`;
const CancelBtn = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-decoration-line: underline;
  color: #058459;
  margin-top: 16px;

  &:hover {
    cursor: pointer;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-body {
      padding: 36px 32px;
      text-align: center;
    }
  }
`;
const ConfirmBtn = styled(Button)`
  border-radius: 100px;
  padding: 14px 32px;
  width: 206px;
  height: 51px;
  color: #ffffff;
  background: #16af7b;
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;

  &:disabled {
    background: #d0d5dd;
    color: #64748b;
  }

  &.ant-btn:hover,
  &.ant-btn:focus {
    color: #16af7b;
    border-color: #16af7b;
  }
`;
const Image = styled.img`
  margin-bottom: 16px;
  width: 144px;
  height: 144px;
`;
